import { render, staticRenderFns } from "./KusClientFormCurrency.vue?vue&type=template&id=4bb819da"
import script from "./KusClientFormCurrency.vue?vue&type=script&lang=js"
export * from "./KusClientFormCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports